import {Component, Input, OnChanges, OnInit, ViewEncapsulation} from '@angular/core';
import {FmcElementsComponent} from '../fmc-elements.component';
import * as moment_ from 'moment';
import {AbstractControl, FormsModule, ReactiveFormsModule, UntypedFormControl, Validators} from '@angular/forms';
import {EMPTY as empty, Observable} from 'rxjs';
import {maxAgeRestriction, minAgeRestriction} from '../validators/dates.directive';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {NgIf} from '@angular/common';

const moment = moment_;

@Component({
  selector: 'fmc-date-text',
  templateUrl: './date-text.component.html',
  styleUrls: ['./date-text.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    NgIf,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule
  ]
})
export class DateTextComponent extends FmcElementsComponent implements OnInit, OnChanges {
  @Input() public maxAgeRestriction = false;
  @Input() public minAgeRestriction = false;
  @Input() public required = false;
  @Input() public centralisedValidation = false;
  public defaultControl = new UntypedFormControl();
  public defaultControlType = 'FormControl';
  public currentDateLength = 0;

  ngOnChanges() {
    // Check for after view init validator updates
    if (!this.centralisedValidation) {
      this.checkRequired();
    }
  }

  ngOnInit() {
    super.ngOnInit();

    if (this.maxAgeRestriction) {
      this.formGroup.get(this.controlName).addValidators(maxAgeRestriction(1212));
      this.formGroup.get(this.controlName).updateValueAndValidity();
    }

    if (this.minAgeRestriction) {
      this.formGroup.get(this.controlName).addValidators(minAgeRestriction(215));
      this.formGroup.get(this.controlName).updateValueAndValidity();
    }

    if (!this.centralisedValidation) {
      this.checkRequired();

      /**
       * Validate that this is the correct format
       */
      this.formGroup.get(this.controlName).setAsyncValidators([(control: AbstractControl) => {
        /** Validates that  */
          // @ts-ignore
        const valid: any = empty.toPromise();
        const invalid: any = new Observable((observer) => {
          observer.next({invalidDate: true});
          observer.complete();
        });

        if (control.value === null
          || control.value === undefined
          || control.value === '') {
          return valid;
        }

        let isValid = true;
        const input = control.value;
        if (input && input.length >= 1) {
          const d = moment(input, 'DD/MM/YYYY', true);
          isValid = d.isValid()
            && d.isBefore(moment('3000-01-01'))
            && d.isSameOrAfter(moment('1900-01-01')); // don't allow ridiculous date inputs
        }
        return isValid ? valid : invalid;
      }]);
    }

    /**
     * Tries to format the string to a dd/mm/yyyy format
     */
    this.formGroup.get(this.controlName).valueChanges.subscribe((value) => {
      let output = value;
      if (value && value.length > this.currentDateLength) { // make sure we do not add slash if backspacing
        value = value.replace(/[^0-9]/g, '');
        const splits = value.match(/.{1,2}/g);
        if (splits) {
          output = '';
          splits.map((e, idx) => {
            output += e;
            if (idx < 2 && e.length === 2) {
              output += '/';
            }
          });
        }
      }

      this.currentDateLength = (output) ? output.length : null;
      if (output !== value) {
        this.formGroup.get(this.controlName).patchValue(output);
      }
    });
  }

  checkRequired() {
    if (this.required && this.formGroup && this.formGroup.get(this.controlName)) {
      this.formGroup.get(this.controlName).addValidators(Validators.required);
      this.formGroup.get(this.controlName).updateValueAndValidity();
    } else if (!this.required && this.formGroup && this.formGroup.get(this.controlName)) {
      this.formGroup.get(this.controlName).removeValidators(Validators.required);
      this.formGroup.get(this.controlName).updateValueAndValidity();
    }
  }

}
